const config = {
    apiAddress: process.env.REACT_APP_API_URL || "http://localhost:8442/tdit/",
    tokenGeneration: {
        key: "XREmSYlhkJkEBLC5kfQktw==",
        grant_type: "password",
        scopes: "admin"
    }
}

export { config }